import "./Home.module.css";
import HeaderPrincipale from "@/reusable_sections/Header";
import HeroDesign from "./sections/HeroDesign";
import EccellenzaNelDesignParte1 from "./sections/EccellenzaNelDesignParte1";
import EccellenzaNelDesignParte2 from "./sections/EccellenzaNelDesignParte2";
import FollowUsOnInstagram from "./sections/FollowUsOnInstagram";
import SupportoDirettoWhatsapp from "./sections/SupportoDirettoWhatsapp";
import OffertaEsclusiva from "./sections/OffertaEsclusiva";
import PromotionalOffer from "./sections/PromotionalOffer";
import VerneLegacy from "./sections/VerneLegacy";
import About from "./sections/About";
import Profile from "./sections/Profile";
import Footer from "./sections/Footer";
import FooterInformativo from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <HeaderPrincipale />
      <HeroDesign />
      <EccellenzaNelDesignParte1 />
      <EccellenzaNelDesignParte2 />
      <FollowUsOnInstagram />
      <SupportoDirettoWhatsapp />
      <OffertaEsclusiva />
      <PromotionalOffer />
      <VerneLegacy />
      <About />
      <Profile />
      <Footer />
      <FooterInformativo />
    </div>;
}